import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Logger } from '@mirohq-internal/telemetry-logging';
import { track } from '../analytics';
import { WebsiteEvents } from '../constants/events';
import { PerformanceMetricNameToTypeMap } from '../constants/performance';
import { getCommonPayload } from './utils';

var isNavigationTiming = function isNavigationTiming(entry) {
  return 'entryType' in entry && entry.entryType === 'navigation';
};

export var reportPerformanceStat = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(metric, pageInfo) {
    var _metric$entries;

    var eventName, commonPayload, promises;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Logger["default"].info("[Performance] ".concat(metric.name, "=").concat(metric.value));
            eventName = PerformanceMetricNameToTypeMap[metric.name];

            if (eventName) {
              _context.next = 5;
              break;
            }

            Logger["default"].info("[Performance] ".concat(metric.name, " skipped"));
            return _context.abrupt("return");

          case 5:
            commonPayload = getCommonPayload();
            promises = [track(eventName, _objectSpread(_objectSpread({
              value: round(metric.value, 2),
              delta: metric.delta ? round(metric.delta, 2) : metric.delta,
              rating: metric.rating,
              navigation_type: metric.navigationType,
              stat_id: metric.id
            }, pageInfo || {}), commonPayload))];

            if ((_metric$entries = metric.entries) !== null && _metric$entries !== void 0 && _metric$entries.length && eventName === PerformanceMetricNameToTypeMap.TTFB && isNavigationTiming(metric.entries[0])) {
              promises.push(reportPageLoading(metric.entries[0], commonPayload, pageInfo));
            }

            _context.next = 10;
            return Promise.all(promises);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function reportPerformanceStat(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var round = function round(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var multiplier = Math.pow(10, decimals);
  return Math.round(value * multiplier) / multiplier;
};

var reportPageLoading = function reportPageLoading(entry, commonPayload, pageInfo) {
  Logger["default"].info('[Performance] Track page loading metrics');
  return track(WebsiteEvents.WEBSITE_PERFORMANCE_PAGE_LOADING_MEASURED, _objectSpread(_objectSpread({
    compression_ratio: entry.decodedBodySize ? round(1 - entry.encodedBodySize / entry.decodedBodySize, 2) : 0,
    decoded_body_size: entry.decodedBodySize,
    dns: round(entry.domainLookupEnd - entry.domainLookupStart),
    dom_content_loaded: round(entry.loadEventEnd - entry.loadEventStart),
    dom_processing: round(entry.domComplete - entry.domInteractive),
    encoded_body_size: entry.encodedBodySize,
    header_size: entry.transferSize ? entry.transferSize - entry.encodedBodySize : 0,
    redirection: round(entry.redirectEnd - entry.redirectStart),
    ssl: entry.secureConnectionStart ? round(entry.connectEnd - entry.secureConnectionStart) : 0,
    tcp: round(entry.connectEnd - entry.connectStart),
    total_duration: round(entry.duration),
    transfer_size: entry.transferSize,
    transferring: round(entry.responseEnd - entry.responseStart),
    ttfb: round(entry.responseStart - entry.requestStart)
  }, pageInfo || {}), commonPayload));
};